import { render, staticRenderFns } from "./CardSlideshowComponent.vue?vue&type=template&id=23fa313b&scoped=true"
import script from "./CardSlideshowComponent.vue?vue&type=script&lang=js"
export * from "./CardSlideshowComponent.vue?vue&type=script&lang=js"
import style0 from "./CardSlideshowComponent.vue?vue&type=style&index=0&id=23fa313b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa313b",
  null
  
)

export default component.exports